/**
 * FASE E — Campo de documento com máscara (CPF ou RG).
 *
 * Um único componente com duas funções:
 *   * CPF  → máscara `000.000.000-00` + aviso de CPF inválido (nunca bloqueia);
 *   * RG   → máscara LEVE (não engessa o formato, que varia por estado).
 *
 * O valor guardado no formulário é o **mascarado** (o backend normaliza: CPF só
 * dígitos). Aviso de CPF aparece embaixo do campo, em amarelo, sem impedir o
 * salvamento — o CPF é OPCIONAL no atleta e no responsável.
 */
import { Input } from './ui/input';
import { Label } from './ui/label';
import { AlertTriangle } from 'lucide-react';
import { cpfWarning, maskDocumento, cleanDocumento } from '../lib/documentos';

export default function CampoDocumento({
  tipo = 'cpf',
  label,
  value,
  onChange,
  testId,
  hint,
  className = '',
}) {
  const aviso = tipo === 'cpf' ? cpfWarning(value) : null;

  return (
    <div className="space-y-1.5">
      {label && <Label className="text-[#A1A1AA] text-xs">{label}</Label>}
      <Input
        value={value || ''}
        // A máscara roda a cada tecla: o CPF nunca aparece sem pontuação.
        onChange={(e) => onChange(maskDocumento(e.target.value, tipo))}
        // Ao SAIR do campo o valor é fechado (sem espaço sobrando nas pontas):
        // é esse valor que o formulário envia e o servidor normaliza igual.
        onBlur={() => onChange(cleanDocumento(value, tipo))}
        inputMode={tipo === 'cpf' ? 'numeric' : 'text'}
        maxLength={tipo === 'cpf' ? 14 : 20}
        placeholder={tipo === 'cpf' ? '000.000.000-00 (opcional)' : 'Ex: 12.345.678-9 (opcional)'}
        data-testid={testId}
        aria-invalid={aviso ? 'true' : 'false'}
        className={`bg-[#1A1A1A] border-[#27272A] text-white ${
          aviso ? 'border-amber-500/60' : ''
        } ${className}`}
      />
      {aviso && (
        <p className="text-micro text-amber-400 flex items-center gap-1">
          <AlertTriangle className="w-3 h-3" /> {aviso}
        </p>
      )}
      {hint && !aviso && <p className="text-micro text-[#71717A] leading-tight">{hint}</p>}
    </div>
  );
}
